export default __webpack_public_path__ + "static/media/heart.6f45a4af.png";